import { RootState } from "../../../store/indexReducers";

export const screenLoaderActive = (state: RootState) =>
  state.loaderReducer.showScreenLoader;
